/*
 * Fund project selection component
 */

import React from 'react';
import Base from './base.jsx';
import {castDataType, DataType,} from '../common.jsx';
import Helpers from './helpers.jsx'
import Setting from './setting.jsx';

import {ReadOnlyMultiSelectValues} from '../../common/Select.jsx';
import ProjectSelect from '../../common/ProjectSelect/ProjectSelect.jsx';

export default class FundProjectAsyncSelect extends Base {

  static get CATEGORY() {
    return 'question';
  }

  static get TYPE() {
    return 'fund_project_async_select';
  }

  static icon() {
    return <i className='adalicon icon-files'></i>;
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'field_default_label',
      placeholder: 'field_default_placeholder',
      description: 'field_default_description',
      help: null
    };
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      label: 'label',
      placeholder: 'placeholder',
      description: 'description',
      name: 'field_' + Helpers.randomString(),
      reportKey: '',
      help: 'help',
      required: false,
      label_hidden: false,
      prettyView: {
        hide: false,
        show_label: false
      }
    });
  }

  hasPrefilledAnswer(context) {
    const prefillAnswers = this.getPrefilledAnswer(context);
    return (prefillAnswers && Object.keys(prefillAnswers).length > 0);
  }

  renderView() {
    const {value = null, label = null} = this.getAnswer();
    const fieldName = this.fullFieldName();

    return (
      <div>
        {this.getLockedInformationTooltip(this.modeFillOrView() && this.isReadOnlyPrefilledAnswer(), <>
          <label className={this.props.content.label_hidden ? 'hidden-label' : ''}>
            <span className="field-label">{this.getText('label')}</span>
            {this.props.content.required && <span className='required-field'> *</span>}
            {this.helpIcon()}
            {this.renderPrefillIcon()}
          </label>

          <ProjectSelect
            name={`${fieldName}][value]`}
            value={value}
            label={label}
            placeholder={this.getText('placeholder')}
            onChange={(val) => this.answerChanged(val)}
            readOnly={!this.isFillMode()}
            disabled={(this.isFillMode() && this.isReadOnlyAnswer()) || this.props.disabled}
          />

          {this.descriptionText()}
          {!this.modeFillOrView() && this.isReadOnlyAnswer() ? this.lockedInformationDefault() : ''}
        </>)}

        {this.isFillMode() && <input type='hidden' name={`${fieldName}][label]`} value={label}/>}
      </div>
    );
  }

  renderPrettyView() {
    const {hide = false, show_label = false} = this.props.content.prettyView || {};
    if (hide) return null;

    const {value = null, label = null} = this.getAnswer();

    return <div>
      {show_label &&
        <label>
          <span className="field-label">{this.getText('label')}</span>
        </label>
      }
      {value ? <ReadOnlyMultiSelectValues values={[{label: label}]}/> : <p><em>{I18n.t('no_selected_options', {scope: 'fe'})}</em></p>}
    </div>;
  }

  answerChanged = (value) => {
    this.updateAnswer(value);
    if (this.props.answersChangedCallback) {
      this.props.answersChangedCallback();
    }
  }

  renderSettings() {
    return (
      <div>
        <Setting.Checkbox name="required" label={I18n.t('field_required', {scope: 'fe'})} value={this.props.content.required} onChange={this.updateSettings}/>
        <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings}/>
        <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings}/>

        {!this.props.settings['hidePlaceholderField'] &&
          <Setting.TextField name="placeholder" label={I18n.t('field_placeholder', {scope: 'fe'})} value={this.getText('placeholder')} onChange={this.updateSettings}/>
        }
        {!this.props.settings['hideDescriptionField'] &&
          <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings}/>
        }
        {!this.props.settings['hideHelpTextField'] &&
          <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings}/>
        }

        <Setting.TextField
          name="reportKey"
          label={I18n.t('field_report_key', {scope: 'fe'})}
          value={this.props.content.reportKey}
          description={I18n.t('field_report_key_description', {scope: 'fe'})}
          {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
        />

        {this.renderPrettyViewSettings()}
      </div>
    );
  }

  beforeUpdateSettings(content) {
    content.required = castDataType(content.required, DataType.BOOLEAN);
    content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
    this.beforeUpdateSettingsPrettyView(content);
  }
}
